<template>
  <div class="page-container">
   <div class="org-content">
      <van-dropdown-menu>
        <van-dropdown-item @change="handleOrgChange" v-model="state.currentOrg" :options="state.orgList" />
      </van-dropdown-menu>
      <van-icon style="position: absolute;right: 12px;" size="20" @click="onRefresh" name="replay" />
    </div>

    <div class="report-content">
        <!-- 当月核心指标 -->
        <div class="current-month-section">
            <div class="current-month-item">
                <div class="current-month-label">当月签约金额</div>
                <div class="current-month-value highlight">{{state.mainStatsData.signAmount ?? 0}}</div>
            </div>
            <div class="current-month-item">
                <div class="current-month-label">当月退款金额</div>
                <div class="current-month-value">{{state.mainStatsData.currentMonthRefundAmount ?? 0}}</div>
            </div>
        </div>
        
        <!-- 分隔线 -->
        <div class="divider"></div>
        
        <!-- 总计指标 -->
        <div class="total-stats-section">
            <div class="total-stat-item">
                <div class="total-stat-label">总签约金额</div>
                <div class="total-stat-value">{{state.mainStatsData.totalAmount}}</div>
            </div>
            <div class="total-stat-item">
                <div class="total-stat-label">总服务学生</div>
                <div class="total-stat-value">{{state.mainStatsData.totalStudent}}</div>
            </div>
            <div class="total-stat-item">
                <div class="total-stat-label">总退款金额</div>
                <div class="total-stat-value">{{state.mainStatsData.refundAmount}}</div>
            </div>
        </div>
    </div>

    <div>
         <div class="header-top">
          <span>数据统计周期：{{ QUICK_TEXT[quickType] }}</span>
          <div
            class="setting-img"
            @click="handleChoiceTimeClick"></div>
        </div>
    </div>

    <div class="report-list" v-if="state.currentOrg != 1 && state.currentOrg != 2">
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>签约学生</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.studentNo ?? 0}}</span>
            </div>
        </div>
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>已生效学生</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.activeStudentNo ?? 0}}</span>
            </div>
        </div>
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>待生效学生</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.inactiveStudentNo ?? 0}}</span>
            </div>
        </div>
        
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>10日内到期</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.dueNo || 0}}</span>
            </div>
        </div>
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>入住人数</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.checkInNo || 0}}</span>
            </div>
        </div>
        <div class="report-item" v-if="quickType == QUICK_KEY.today">
            <div class="row-column">
                <span>床位使用率</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{((state.staticData.manageData?.bedRate || 0) * 100).toFixed(2)}}%</span>
            </div>
        </div>
        <div class="report-item">
            <div class="row-column">
                <span>新增签约单</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.newSignNo || 0}}</span>
            </div>
        </div>
        <div class="report-item">
            <div class="row-column">
                <span>签约金额</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.newSignAmount || 0}}</span>
            </div>
        </div>
        <div class="report-item" v-if="quickType != QUICK_KEY.today">
            <div class="row-column">
                <span>到期未续</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.dueNo || 0}}</span>
            </div>
        </div>

        <div class="report-item">
            <div class="row-column">
                <span>退款金额</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.staticData.manageData?.refundAmount || 0}}</span>
            </div>
        </div>
        
    </div>

    <div class="report-list" v-if="state.currentOrg == 1 || state.currentOrg == 2">
        <div class="report-item">
            <div class="row-column">
                <span>新增签约单</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.academyManagementData?.newSignNo || 0}}</span>
            </div>
        </div>
        <div class="report-item">
            <div class="row-column">
                <span>签约金额</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.academyManagementData?.newSignAmount || 0}}</span>
            </div>
        </div>

        <div class="report-item">
            <div class="row-column">
                <span>退款金额</span>
                <span style="color: #113050;margin-top: 6px;font-size: 18px">{{state.academyManagementData?.refundAmount || 0}}</span>
            </div>
        </div>
    </div>

    <div class="report-table" v-if="state.currentOrg != 1 && state.currentOrg != 2">
      <div class="report-title">新增签约</div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.staticData.newSignData"
        :columns="addColumns"
      />
    </div>

    <div style="margin-top: 10px" class="report-table" v-if="state.currentOrg != 1 && state.currentOrg != 2">
       <div class="report-title">新增退款明细</div>
        <SortPaginationTable
        style="margin-top: 10px"
        :data="state.staticData.refundDetailData"
        :columns="refundDetailColumns"
        :pagination="false"
      />
    </div>

    <div class="report-table" style="margin-top: 10px" v-if="quickType != QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
      <div class="report-title">导师业绩统计</div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.performanceStatisticsTableList"
        :columns="performanceStatisticsColumns"
      />
    </div>

    <div class="student-chart" v-if="quickType == QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
       <div class="report-title">签约学生</div>
        <StudentCharts ref="studentChart"  v-if="state.staticData.studentCountByProduct && state.staticData.studentCountByProduct.length > 0" :data="state.staticData.studentCountByProduct" />
        <EmptyData style="margin-top: 100px" v-else/>
    </div>

    

    <div class="report-table" v-if="quickType == QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
      <div class="report-title" style="display: flex; align-items: center;">
        导师学生
        <van-icon
          name="question-o"
          style="margin-left: 6px; color: #999; font-size: 18px; cursor: pointer;"
          @click="showTutorStudentTip"
        />
      </div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.tableList"
        :columns="columns"
      />
    </div>

    <div class="report-table" style="margin-top: 10px" v-if="quickType == QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
      <div class="report-title">10日内到期</div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.expireTableList"
        :columns="expireColumns"
      />
    </div>

    <div class="student-chart" v-if="quickType == QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
       <div class="report-title">入住人数</div>
        <StudentNumCharts ref="studentNumChart"  v-if="state.staticData.bedData" :data="state.staticData.bedData" />
        <EmptyData style="margin-top: 100px" v-else/>
    </div>

    <div class="student-chart" v-if="quickType == QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
       <div class="report-title">床位使用率</div>
        <BedRateRunCharts ref="studentNumChart"  v-if="state.staticData.bedData" :data="state.staticData.bedData" />
        <EmptyData style="margin-top: 100px" v-else/>
    </div>

    

    <div class="student-chart-container" v-if="quickType != QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
       <div class="report-title">类型分布</div>
        <div style="height: 300px;">
          <TypeDistributionBar ref="typeDistributionBarChart"  v-if="state.staticData.studentCountByProduct && state.staticData.studentCountByProduct.length > 0" :data="state.staticData.studentCountByProduct" />
          <EmptyData v-else/>
        </div>

         <div style="margin-top: 16px;height: 300px;">
          <TypeDistributionPie ref="typeDistributionPieChart"  v-if="state.staticData.newRenewData && !(state.staticData.newRenewData.newSignNo ==0 && state.staticData.newRenewData.newSignNo == 0)" :data="state.staticData.newRenewData" />
          <EmptyData v-else/>
        </div>
    </div>
    <div class="report-table" v-if="quickType != QUICK_KEY.today && state.currentOrg != 1 && state.currentOrg != 2">
      <div class="report-title">到期未续约</div>
      <SortPaginationTable
        style="margin-top: 10px"
        :data="state.expireTableList"
        :columns="expireColumns"
      />
    </div>

    <div class="student-chart" v-if="state.currentOrg == 1 || state.currentOrg == 2">
       <div class="report-title">书院经营数据</div>
        <DistributionDataCharts ref="studentNumChart"  v-if="state.academyManagementData.distributionData.length" :data="state.academyManagementData.distributionData" />
        <EmptyData style="margin-top: 100px" v-else/>
    </div>



    <van-popup
      v-model:show="isShowPopup"
      closeable
      position="bottom"
      @click-overlay="handleClose"
      @click-close-icon="handleClose">
      <date-filter-panel
        @submit="handleChoiceTime"
        :config="{ quickType: quickType }"></date-filter-panel>
    </van-popup>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { queryBusinessUserData, querySelectOrgListByUser, querySyDataStatisticsMainStats, querySyDataStatisticsMainDatas } from '@/api/user'
import { useRoute } from "vue-router";
import EmptyData from '@/components/EmptyData.vue';
import DateFilterPanel from '@/components/dateFilterPanel/DateFilterPanel.vue';
import { getDateRangeByType, QUICK_KEY, QUICK_TEXT } from '@/components/dateFilterPanel/utils.js';
import StudentCharts from '@/components/StudentCharts.vue'
import SortPaginationTable from "@/components/business/SortPaginationTable.vue";
import dayjs from "dayjs";
import StudentNumCharts from '@/components/StudentNumCharts.vue'
import BedRateRunCharts from '@/components/BedRateRunCharts.vue'
import TypeDistributionPie from '@/components/TypeDistributionPie.vue'
import TypeDistributionBar from '@/components/TypeDistributionBar.vue'
import { showLoadingToast, closeToast, showToast } from 'vant';
import DistributionDataCharts from '@/components/DistributionDataCharts.vue'
const columns = [
  {
    title: "导师",
    dataIndex: "staffName",
    width: 50,
    start: true
  },
  {
    title: "当前学生",
    dataIndex: "stuNo",
    width: 40,
  },
  {
    title: "签约产品",
    dataIndex: "productCountStr",
    isPup: true,
    width: 180,
  },
  {
    title: "签约金额",
    dataIndex: "signAmount",
    width: 80,
  },
];

const expireColumns = [
  {
    title: "导师",
    dataIndex: "staffName",
    width: 50,
    start: true,
  },
  {
    title: "学生",
    dataIndex: "stuName",
    width: 60,
  },
  {
    title: "签约产品",
    dataIndex: "businessNameDate",
    isPup: true,
  }
];

const refundDetailColumns = [
  {
    title: "导师",
    dataIndex: "staffName",
    width: 50,
    start: true,
  },
  {
    title: "学生",
    dataIndex: "studentName",
    width: 60,
  },
  {
    title: "签约产品",
    dataIndex: "businessName",
    isPup: true,
    isRefundProduct: true,
    width: 120,
  },
  {
    title: "签约金额",
    dataIndex: "signMoney",
  },
  {
    title: "退款金额",
    dataIndex: "refundAmount",
  },
  
]


const performanceStatisticsColumns = [
  {
    title: "导师",
    dataIndex: "staffName",
  },
  {
    title: "学生数量",
    dataIndex: "stuNo",
  },
  {
    title: "付款金额(元)",
    dataIndex: "signAmount",
  },
  {
    title: "退款金额(元)",
    dataIndex: "refundAmount",
  }
]


const addColumns = [
  {
    title: "导师",
    dataIndex: "staffName",
    width: 50,
    start: true,
  },
  {
    title: "学生",
    dataIndex: "stuName",
    width: 60,
  },
  {
    title: "签约产品",
    dataIndex: "businessName",
    isPup: true,
    isAddProduct: true
  },
  {
    title: "类型",
    dataIndex: "signTypeDesc",
  },
  {
    title: "签约金额",
    dataIndex: "signMoney",
  }
];

export default defineComponent({
  name: "ManagementPanel",

  components: {
    EmptyData,
    DateFilterPanel,
    StudentCharts,
    SortPaginationTable,
    StudentNumCharts,
    BedRateRunCharts,
    TypeDistributionBar,
    TypeDistributionPie,
    DistributionDataCharts
  },

  setup() {
    const defaultQuickType = QUICK_KEY.today;
    const defaultQuery = getDateRangeByType(defaultQuickType);

    console.log('defaultQuery>>>',defaultQuery)
    const quickType = ref(defaultQuickType);

    const route = useRoute();
    const state = reactive({
      academyManagementData: {
        refundAmount: 0,
        newSignNo: 0,
        newSignAmount: 0,
        distributionData: []
      },
      loading: false,
      isFinsh: false,
      currentOrg: null,
      orgList: [],
      totalMoney: 0,
      mainStatsData: {
        totalAmount: 0,
        refundAmount: 0,
        totalStudent: 0,
        signAmount: 0,
        currentMonthRefundAmount: 0,
      },
      staticData: {
        manageData: {
          refundAmount: 0,
          bedRate: 0,
          checkInNo: 0,
          dueNo: 0,
          newSignNo: 0,
          studentNo: 0,
          newSignAmount: 0
        },
        studentCountByProduct: [],
        bedData: [],
        refundDetailData: []
      },
      tableList:[],
      expireTableList:[],
      performanceStatisticsTableList: [],
      params: {
        endTime: defaultQuery[1],
        startTime: defaultQuery[0]
      }
    })

    const isShowPopup = ref(false);
    onMounted(() => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }
      
      querySysOrgListByUser();
      // getBusinessUserData()
      
    });

    const onRefresh = async () => {
      console.log('刷新')
      try {
        state.loading = true;
        const toast = showLoadingToast({
          message: '数据刷新中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        });
        
        // 并行执行两个方法
        await Promise.all([
          (state.currentOrg == 1 || state.currentOrg == 2) ? getAcademyManagementData() : getBusinessUserData(),
          getCurrentMonthrData(),
        ]);
        
        closeToast();
      } catch (error) {
        console.log("refresh error:", error);
        closeToast();
      }
    }

    const querySysOrgListByUser = async () => {
      state.orgList = [];
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
        const result = await querySelectOrgListByUser({
          id: userInfo?.id,
        });
        console.log("result:", result);
        if (result.code === "00") {
          state.orgList = result.data.map(item => {
            return {
              ...item,
              text: item.name,
              value: item.id
            }
          }).sort((a, b) => a.id - b.id) ?? [];

          if(route?.query?.currentOrg) {
            state.currentOrg = Number(route?.query?.currentOrg)
          } else {
            state.currentOrg = state.orgList[0].value
          }

          // 并行执行两个方法
          await Promise.all([
            (state.currentOrg == 1 || state.currentOrg == 2) ? getAcademyManagementData() : getBusinessUserData(),
            getCurrentMonthrData()
          ]);
          
        }
      } catch (error) {
        state.orgList = []
      }
    }

    

    const getBusinessUserData = async () => {
      try {
        state.loading = true;
        const params = {
          ...state.params,
          createOrg: state.currentOrg,
        }
        if(quickType.value === QUICK_KEY.today) {
          delete params.endTime
        }
        const result = await queryBusinessUserData({
          ...params
        });
        if (result.code === "00") {
          state.staticData = result.data;
          state.expireTableList = result.data.dueData.map(item => {
            return {
              ...item,
              businessNameDate: `${item.businessName}(${dayjs(item.startTime).format('YYYY-MM-DD')}-${dayjs(item.endTime).format('YYYY-MM-DD')})`
            }
          })
          state.tableList = result.data.staffData.map(item => {
            const str = item.productCount.map(h => `${h.businessName}:${h.stuNo}`)
            return {
              ...item,
              productCountStr: str.join('、')
            }
          })

          state.performanceStatisticsTableList = result.data?.staffAggregateData ?? []
          state.staticData.refundDetailData = result.data?.refundDetailList ?? []
          state.loading = false;
        } else {
        }
        // 移除这里的closeToast，让两个方法都完成后再关闭
      } catch (error) {
        console.log("error:>>>", error);
        closeToast()
      }
    }

    const getCurrentMonthrData = async () => {
      try {
        const defaultQuery = getDateRangeByType(QUICK_KEY.currentMonth);

        const params = {
          startTime: defaultQuery[0],
          createOrg: state.currentOrg,
        }
        const result = await querySyDataStatisticsMainStats({
          ...params
        });
        if (result.code === "00") {
          
          state.mainStatsData.totalAmount = result.data.totalAmount ?? 0;
          state.mainStatsData.refundAmount = result.data.refundAmount ?? 0;
          state.mainStatsData.totalStudent = result.data.totalStudent ?? 0;
          state.mainStatsData.signAmount = result.data.currentMonthAmount ?? 0;
          state.mainStatsData.currentMonthRefundAmount = result.data.currentMonthRefundAmount ?? 0;
        } else {
        }
        // 在这里关闭loading，因为两个方法都完成了
      } catch (error) {
        console.log("error:>>>", error);
        closeToast()
      }
    }


    const getAcademyManagementData = async () => {
      try {
        const params = {
          ...state.params,
          createOrg: state.currentOrg,
        }
        if(quickType.value === QUICK_KEY.today) {
          delete params.endTime
        }
        const result = await querySyDataStatisticsMainDatas({
          ...params
        });
      
        if (result.code === "00") {
          state.academyManagementData.newSignNo = result.data.newSignNo ?? 0;
          state.academyManagementData.newSignAmount = result.data.newSignAmount ?? 0;
          state.academyManagementData.distributionData = result.data.distributionData ?? [];
          state.academyManagementData.refundAmount = result.data.totalRefundAmount ?? 0;
        } else {
        }
        // 在这里关闭loading，因为两个方法都完成了
      } catch (error) {
        console.log("error:>>>", error);
        closeToast()
      }
    }


    const handleOrgChange = async (value) => {
      state.currentOrg = value
      try {
        state.loading = true;
        const toast = showLoadingToast({
          message: '数据刷新中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
        });
        
        // 并行执行两个方法
        await Promise.all([
          (state.currentOrg == 1 || state.currentOrg == 2) ? getAcademyManagementData() : getBusinessUserData(),
          getCurrentMonthrData(),
        ]);
        
        closeToast();
      } catch (error) {
        console.log("org change error:", error);
        closeToast();
      }
    }

    const handleChoiceTimeClick = () => {
        isShowPopup.value = true;
    };

    const handleChoiceTime = async (ops) => {
        const [beginAt, endAt] = ops.dateRange;
        quickType.value = ops.quickType;
        state.params.startTime = beginAt
        state.params.endTime = endAt
        isShowPopup.value = false;
        
        try {
          state.loading = true;
          const toast = showLoadingToast({
            message: '数据刷新中...',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          });
          
          // 并行执行两个方法
          await Promise.all([
            (state.currentOrg == 1 || state.currentOrg == 2) ? getAcademyManagementData() : getBusinessUserData(), 
          ]);
          
          closeToast();
        } catch (error) {
          console.log("choice time error:", error);
          closeToast();
        }
    };

      const handleClose = () => {
        isShowPopup.value = false;
      };

    const showTutorStudentTip = () => {
      showToast('当前所有签约中的学生，包括未生效。');
    };

    return {
      state,
      handleOrgChange,
      handleChoiceTimeClick,
      handleChoiceTime,
      handleClose,
      QUICK_TEXT,
      quickType,
      QUICK_KEY,
      isShowPopup,
      columns,
      expireColumns,
      addColumns,
      performanceStatisticsColumns,
      onRefresh,
      showTutorStudentTip,
      refundDetailColumns

    };
  },
});
</script>

<style lang="scss" scoped>
.page-container {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  margin-bottom: 24px;
}

.org-content {
  margin: 6px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

:deep(.van-dropdown-menu__bar) {
  background: none !important;
  box-shadow: none !important;
}

.report-content {
  margin: 12px 6px;
  padding: 10px 6px;
  //width: calc(100% - 12px);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 当月核心指标区域 */
.current-month-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
}

.current-month-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px;
}

.current-month-item:first-child {
  border-right: 1px solid #f0f0f0;
  padding-right: 20px;
}

.current-month-item:last-child {
  padding-left: 20px;
}

.current-month-label {
  font-size: 13px;
  color: #86909c;
  margin-bottom: 8px;
  font-weight: 400;
}

.current-month-value {
  font-size: 20px;
  color: rgb(17, 48, 80);
  font-weight: 500;
}

.current-month-value.highlight {
  font-size: 28px;
  color: #f5a623;
  font-weight: 600;
}

/* 分隔线 */
.divider {
  height: 1px;
  background: #f0f0f0;
}

/* 总计指标区域 */
.total-stats-section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 16px 0 8px;
}

.total-stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 12px;
  position: relative;
}

.total-stat-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #f0f0f0;
}

.total-stat-label {
  font-size: 12px;
  color: #86909c;
  margin-bottom: 8px;
  font-weight: 400;
}

.total-stat-value {
  font-size: 18px;
  color: rgb(17, 48, 80);
}

.row-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.report-list {
    margin: 12px 6px;
    // padding-top: 14px;
    width: calc(100% - 12px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.report-item {
    width: calc(50% - 28px);
    background-color: #fff;
    border-radius: 7px;
    margin-top: 6px;
    padding: 12px;
}

.header-top {
      background: #ffffff;
      margin-top: 1px;
      display: flex;
      justify-content: space-between;
      height: 40px;
      color: #86909c;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      align-items: center;
      padding-left: 12px;
      padding-right: 12px;
    }

    .setting-img {
      height: 18px;
      width: 18px;
      background-repeat: no-repeat;
      background-image: url(~@/assets/setting.png);
      background-size: contain;
    }

    .student-chart {
      margin: 12px 10px;
      width: calc(100% - 20px);
      height: 340px;
      background-color: #fff;
      border-radius: 7px;
    }

     .student-chart-container {
      margin: 12px 10px;
      width: calc(100% - 20px);
      height: 680px;
      background-color: #fff;
      border-radius: 7px;
    }

    .report-title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 17px;
    color: #000000;
    text-align: left;
    padding-left: 10px;
    padding-top: 10px;
  }

  .report-table {
    width: calc(100% - 20px);
    background-color: #fff;
    margin: 0 12px;
    border-radius: 7px;
    padding-top: 12px;
  }

</style>